import { render, staticRenderFns } from "./CommonUploadOtherBank.vue?vue&type=template&id=0ec7fc0b&scoped=true"
import script from "./CommonUploadOtherBank.vue?vue&type=script&lang=js"
export * from "./CommonUploadOtherBank.vue?vue&type=script&lang=js"
import style0 from "./CommonUploadOtherBank.vue?vue&type=style&index=0&id=0ec7fc0b&prod&lang=css"
import style1 from "./CommonUploadOtherBank.vue?vue&type=style&index=1&id=0ec7fc0b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ec7fc0b",
  null
  
)

export default component.exports